import React from 'react';

import { makeMuiStyles } from '@styles';
import { createStrings } from '@utils/local';

export const strings = createStrings({
  ja: {
    title: '〜ご参考〜',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.middleText,
    color: theme.palette.grey['500'],
    textAlign: 'center',
    padding: '1rem 2rem',
    backgroundColor: theme.palette.background.default,
    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0.5rem 1rem',
    },
  },
}));

export const Reference: React.FC<React.PropsWithChildren<{}>> = (props) => {
  const classes = useStyles();

  const { children } = props;

  return (
    <div className={classes.container}>
      {strings.title}
      <br />
      <br />
      {children}
    </div>
  );
};
